import { MILESTONES_ACHIEVED_CARDS, MILESTONES_SECTION } from '../../../data/site';

export function MilestonesSection() {
  const [safetyNet, invest, spendSmarter] = MILESTONES_ACHIEVED_CARDS;

  return (
    <section className="milestones">
      <div className="container">
        <div className="milestones-wrap">
          <div className="section-header-wrap">
            <div className="section-header-content">
              <div className="section-header-text-wrap">
                <div className="heading-wrap">
                  <h2 className="text-center">{MILESTONES_SECTION.title}</h2>
                </div>
                <div className="subtitle-wrap">
                  <div className="paragraph-02 center-dark-gray">{MILESTONES_SECTION.subtitle}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="milestones-main-wrap">
            <div className="milestones-card">
              <div className="milestones-card-top">
                <div className="milestones-image-wrap">
                  <img src={safetyNet.image} loading="lazy" alt={safetyNet.alt} className="fit-cover" />
                </div>
              </div>
              <div className="milestones-text-wrap">
                <div className="text-style-h5">{safetyNet.title}</div>
                <div className="tag text-dark-grey-two">{safetyNet.description}</div>
              </div>
            </div>

            <div className="milestones-card">
              <div className="milestones-card-top">
                <div className="milestones-image-wrap">
                  <img src={invest.image} loading="lazy" alt={invest.alt} className="fit-cover milestones-image" />
                  <div className="milestones-image-cover" />
                  <div className="milestones-card-content milestones-card-content--cta-only">
                    <div className="reason-button-wrap">
                      <a href="/waitlist" className="button w-variant-6cc8cb48-f4c6-5f39-f8af-bcfb630263e0 w-inline-block">
                        <div className="button-text-wrap">
                          <div className="button-text-group">
                            <div className="paragraph-02 button-text-wrap w-variant-6cc8cb48-f4c6-5f39-f8af-bcfb630263e0">
                              Download Now
                            </div>
                            <div className="paragraph-02 button-text-wrap w-variant-6cc8cb48-f4c6-5f39-f8af-bcfb630263e0">
                              Download Now
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="milestones-text-wrap">
                <div className="text-style-h5">{invest.title}</div>
                <div className="tag text-dark-grey-two">{invest.description}</div>
              </div>
            </div>

            <div className="milestones-card">
              <div className="milestones-card-top">
                <div className="milestones-image-wrap">
                  <img src={spendSmarter.image} loading="lazy" alt={spendSmarter.alt} className="fit-cover" />
                </div>
              </div>
              <div className="milestones-text-wrap">
                <div className="text-style-h5">{spendSmarter.title}</div>
                <div className="tag text-dark-grey-two">{spendSmarter.description}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
